import React from "react";
import { AvatarItem } from "./AvatarItem";

interface AvatarOption {
  id: number;
  url: string;
  alt: string;
}

interface AvatarListProps {
  avatars: AvatarOption[];
  defaultAvatars: AvatarOption[];
  selectedAvatar: number | null;
  onSelect: (id: number) => void;
  onDelete: (id: number) => void;
}

export const AvatarList = ({
  avatars,
  defaultAvatars,
  selectedAvatar,
  onSelect,
  onDelete,
}: AvatarListProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {avatars.map((avatar) => (
        <AvatarItem
          key={avatar.id}
          id={avatar.id}
          url={avatar.url}
          alt={avatar.alt}
          isSelected={selectedAvatar === avatar.id}
          isDefault={defaultAvatars.some(a => a.id === avatar.id)}
          onSelect={onSelect}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};